import { useEffect, useState } from 'react'

const checkInAppBrowser = () => {
  if (typeof window === 'undefined') return false

  const userAgent = navigator.userAgent.toLowerCase()

  const isFacebook = /fbav|fbios|fb_iab|fban/.test(userAgent)
  const isInstagram = /instagram/.test(userAgent)
  const isKakao = /kakaotalk/.test(userAgent)
  const isNaver = /naver/.test(userAgent)
  // const isNaver = /naver\(inapp\)/.test(userAgent)

  return isFacebook || isInstagram || isKakao || isNaver
}

const useIsInApp = () => {
  const [isInApp, setIsInApp] = useState(checkInAppBrowser())

  useEffect(() => {
    // 만약 나중에 추가로 특정 조건에 따라 isInApp을 업데이트할 필요가 있다면 여기에 로직 추가
  }, [])

  return isInApp
}

export default useIsInApp
